<div class="dataset-table table-container">
  <table cdk-table [dataSource]="dataSource">
    <ng-container cdkColumnDef="name">
      <th cdk-header-cell *cdkHeaderCellDef>Dataset</th>
      <td cdk-cell *cdkCellDef="let element">
        <p>
          <capra-icon [class.already-imported]="element.alreadyImported" icon="icon-dataset"></capra-icon>
          <span [class.already-imported]="element.alreadyImported" [title]="element.name">{{
            element.name
          }}</span>
          <span [class]="{ 'used-in-report': element.alreadyImported }" *ngIf="element.alreadyImported">
            (used in Report)
          </span>
        </p>
      </td>
    </ng-container>
    <ng-container cdkColumnDef="description">
      <th cdk-header-cell *cdkHeaderCellDef>Description</th>
      <td cdk-cell *cdkCellDef="let element">
        <span [class]="{ 'already-imported': element.alreadyImported }">{{ element.description }}</span>
      </td>
    </ng-container>

    <ng-container *ngIf="displayedColumns.includes('collection')" cdkColumnDef="collection">
      <th cdk-header-cell *cdkHeaderCellDef>Collection</th>
      <td cdk-cell *cdkCellDef="let element">
        <span class="collection-span" [class]="{ 'already-imported': element.alreadyImported }">{{
          element.collection
        }}</span>
      </td>
    </ng-container>
    <ng-container *ngIf="displayedColumns.includes('collection')" cdkColumnDef="creator">
      <th cdk-header-cell *cdkHeaderCellDef>Creator</th>
      <td
        cdk-cell
        *cdkCellDef="let element"
        (mouseover)="enableToolTipControl($event)"
        (mouseout)="hideToolTipControl()"
      >
        <span
          class="creator-span"
          capraTooltip
          tooltipPlacement="bottom"
          [tooltipContent]="element.creator ?? 'N/A'"
          [tooltipIsDisabled]="!toolTipEnabled"
          tooltipDelay="500"
          tooltipSize="mini"
          >{{ element.creator ?? 'N/A' }}</span
        >
      </td>
    </ng-container>
    <ng-container cdkColumnDef="lastRefreshed">
      <th cdk-header-cell *cdkHeaderCellDef>Last run</th>
      <td cdk-cell *cdkCellDef="let element">
        <span class="last-refreshed-span" [class]="{ 'already-imported': element.alreadyImported }">
          {{ element.lastRefreshed | timeAgo }}
        </span>
      </td>
    </ng-container>
    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
    <tr
      cdk-row
      *cdkRowDef="let row; columns: displayedColumns"
      (click)="selectDatasetItem(row)"
      [class]="{ 'selected-row': selectedRow.isSelected(row), 'already-imported': row.alreadyImported }"
      data-test="dataset"
    ></tr>
  </table>
  <mode-pagination-view
    *ngIf="datasetsPagination && enableDatasetsPagination"
    [pagination]="datasetsPagination"
    paginationStyle="link"
    (currentPageChange)="handleChangeCurrentPage($event)"
    class="pagination-container"
  ></mode-pagination-view>
</div>
